const domReady = (callback) => {
  if (document.attachEvent ? (document.domReadyState === 'complete') : (document.readyState !== 'loading')) {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
};

export default domReady;
